import { useState, useEffect } from 'react';
import './IntroSplash.css';
import Logo from "../assets/Aadvi-logo.png";

const IntroSplash = ({ onComplete }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [particles, setParticles] = useState([]);

    useEffect(() => {
        // Preload logo image for faster display
        const img = new Image();
        img.src = Logo;

        // floating particles
        const generateParticles = () => {
            const newParticles = [];
            for (let i = 0; i < 15; i++) {
                newParticles.push({
                    id: i,
                    size: Math.random() * 15 + 5,
                    left: Math.random() * 100,
                    delay: Math.random() * 2,
                    duration: Math.random() * 3 + 2
                });
            }
            setParticles(newParticles);
        };

        generateParticles();

        // Lock body scroll
        document.body.style.overflow = 'hidden';

        // visible time
        const timer = setTimeout(() => {
            setIsVisible(false);
            setTimeout(() => {
                document.body.style.overflow = 'auto';
                onComplete();
            }, 800); 
        }, 4000); 

        return () => {
            clearTimeout(timer);
            document.body.style.overflow = 'auto';
        };
    }, [onComplete]);

    const handleSkip = () => {
        setIsVisible(false);
        setTimeout(() => {
            document.body.style.overflow = 'auto';
            onComplete();
        }, 600);
    };

    return (
        <div className={`intro-splash ${!isVisible ? 'fade-out' : ''}`} onClick={handleSkip}>
            {/* Floating particles */}
            {particles.map(particle => (
                <div 
                    key={particle.id}
                    className="floating-particle"
                    style={{
                        width: `${particle.size}px`,
                        height: `${particle.size}px`,
                        left: `${particle.left}%`,
                        animationDelay: `${particle.delay}s`,
                        animationDuration: `${particle.duration}s`
                    }}
                />
            ))}
            
            {/* Fashion icon decorators */}
            <div className="fashion-icon fashion-icon-1">👗</div>
            <div className="fashion-icon fashion-icon-2">👠</div>
            <div className="fashion-icon fashion-icon-3">💎</div>
            <div className="fashion-icon fashion-icon-4">👜</div>
            
            <div className="splash-content">
                <div className="splash-logo">
                    <div className="logo-circle">
                        <div className="logo-sparkle"></div>
                        <img 
                            src={Logo} 
                            alt="Label Aadvi" 
                            className="logo-image" 
                        />
                    </div>
                </div>
                
                <div className="text-container">
                    <div className="welcome-text">Welcome to</div>
                    <h1 className="splash-title">
                        <span className="title-letter" style={{ '--i': 0 }}>L</span>
                        <span className="title-letter" style={{ '--i': 1 }}>a</span>
                        <span className="title-letter" style={{ '--i': 2 }}>b</span>
                        <span className="title-letter" style={{ '--i': 3 }}>e</span>
                        <span className="title-letter" style={{ '--i': 4 }}>l</span>
                        <span className="title-letter" style={{ '--i': 5 }}>&nbsp;</span>
                        <span className="title-letter" style={{ '--i': 6 }}>A</span>
                        <span className="title-letter" style={{ '--i': 7 }}>a</span>
                        <span className="title-letter" style={{ '--i': 8 }}>d</span>
                        <span className="title-letter" style={{ '--i': 9 }}>v</span>
                        <span className="title-letter" style={{ '--i': 10 }}>i</span>
                    </h1>
                    <div className="splash-subtitle">Premium Fashion Boutique</div>
                </div>
                
                <div className="loading-bar">
                    <div className="loading-progress"></div>
                </div>
                
                <div className="skip-hint">Tap anywhere to skip</div>
            </div>
        </div>
    );
};

export default IntroSplash;